import { Injectable } from '@angular/core';
import { CryptoService } from './CryptoService';


@Injectable()
export class StorageService {
  
  constructor(private cryptoService: CryptoService) {

  }

  set(key, value) {
    localStorage.setItem(key, this.cryptoService.Encrypt(value));
  }

  get(key) : string {
    let value = localStorage.getItem(key);
    return this.cryptoService.Decrtpt(value);
  }

  remove(key) {
    return localStorage.removeItem(key);
  }

  clearAll() {
    localStorage.clear();
  }

}
